// extracted by mini-css-extract-plugin
export default {"wrapper":"Category_wrapper__6fvGi"};